export const appGlobals = {
  omitReloadNotification: false,
};
